<div
  class="col-auto my-2 has-validation"
  [class.validated-dropdown--inline]="inlineLabel()"
>
  <div class="validated-dropdown__main">
    <label
      class="form-label"
      [class.required]="hasRequiredValidator()"
      for="{{ inputFormControlName() }}"
    >
      {{ label() | translate }}
    </label>
    <div
      class="validated-dropdown__field"
      [class.validated-dropdown__field--loading]="loading()"
    >
      @if (loading()) {
        <div class="validated-dropdown__loading" aria-busy="true">
          <span class="spinner-border spinner-border-sm" role="status"></span>
        </div>
      }
      <select
        class="form-select"
        id="{{ inputFormControlName() }}"
        [formControl]="inputFormControl()"
        [compareWith]="compareWith"
        [attr.required]="hasRequiredValidator()"
        [attr.aria-busy]="loading()"
        (change)="onSelectChange()"
      >
        @if (haveEmptyOption()) {
          <option></option>
        }
        <ng-content />
      </select>
    </div>
  </div>

  @if (inputFormControl().touched && inputFormControl().invalid) {
    <div class="feedback">
      <div *ngIf="errorKeys().length > 0">
        {{ getErrorMessage(errorKeys()[0]) | translate }}
      </div>
    </div>
  } @else if (leaveSpaceForValidation()) {
    <div class="placeholder-feedback"></div>
  }
</div>
